import React from 'react';
import './HeroModern.css';
import { Link } from 'react-router-dom';
import { FaCloud, FaShieldAlt, FaProjectDiagram, FaRobot } from 'react-icons/fa';

export default function HeroModern() {
  return (
    <section className="hero-modern">
      <div className="hero-modern-inner content-shell">
        <div className="hero-modern-left">
          <div className="hero-card">
            <div className="hero-card-icon"><FaCloud /></div>
            <h3 className="hero-card-title">AI + <span className="accent">Cloud</span></h3>
            <div className="hero-card-divider" />
            <p className="hero-card-copy">Architecture, automation &amp; AI-enabled delivery</p>
            <Link className="hero-cta" to="/content">Explore Solutions</Link>
          </div>
        </div>

        <div className="hero-modern-right" aria-hidden="true">
          <div className="orb-wrap">
            <div className="orb-rings">
              <div className="ring ring-a" />
              <div className="ring ring-b" />
              <div className="ring ring-c" />
            </div>
            <div className="orb-core">AI +<br/>CLOUD</div>
            <div className="orb-particles">
              <span className="p p1" />
              <span className="p p2" />
              <span className="p p3" />
            </div>
          </div>
        </div>
      </div>

      <div className="hero-modern-features content-shell">
        <div className="feature"><FaRobot className="feature-icon" /><div><strong>AI-Powered</strong><div className="feature-sub">Intelligent automation and insights</div></div></div>
        <div className="feature"><FaCloud className="feature-icon" /><div><strong>Cloud-Native</strong><div className="feature-sub">Scalable, secure & highly available</div></div></div>
        <div className="feature"><FaProjectDiagram className="feature-icon" /><div><strong>Modern Architecture</strong><div className="feature-sub">Microservices, API-first & event-driven</div></div></div>
        <div className="feature"><FaShieldAlt className="feature-icon" /><div><strong>Secure by Design</strong><div className="feature-sub">Built with security, compliance & privacy</div></div></div>
      </div>
    </section>
  );
}
